import depositButtonWorkflow from '../deposit-common/depositButtonWorkflow';
import depositWorkflow from '../deposit-common/depositWorkflow';

export default (function (options) {
  depositButtonWorkflow();
  depositWorkflow(options);
});
//# sourceMappingURL=workflow.js.map